import { Node as MarkdownNode } from "commonmark";
import { HeadingLevel } from "../components/Heading";

export interface Text {
  type: "Text";
  text: string;
}

export interface Break {
  type: "Break";
  variant: "Line" | "Soft";
}

export interface HTMLInline {
  type: "HTMLInline";
  html: string;
}

export interface HTMLBlock {
  type: "HTMLBlock";
  html: string;
}

export interface Code {
  type: "Code";
  code: string;
}

export interface CodeBlock {
  type: "CodeBlock";
  info: string | null;
  code: string;
}

export interface ThematicBreak {
  type: "ThematicBreak";
}

export interface CustomInline {
  type: "CustomInline";
  text: string;
}

export interface CustomBlock {
  type: "CustomBlock";
  text: string;
}

export type LeafNode =
  | Text
  | Break
  | HTMLInline
  | HTMLBlock
  | Code
  | CodeBlock
  | ThematicBreak
  | CustomInline
  | CustomBlock;

export interface Document {
  type: "Document";
  childNodes: Array<Node>;
}

export interface TextStyle {
  type: "TextStyle";
  variant: "Emph" | "Strong";
  childNodes: Array<Node>;
}

export interface Link {
  type: "Link";
  href: string;
  title: string | null;
  childNodes: Array<Node>;
}

export interface Image {
  type: "Image";
  src: string;
  title: string | null;
  childNodes: Array<Node>;
}

export interface Paragraph {
  type: "Paragraph";
  childNodes: Array<Node>;
}

export interface BlockQuote {
  type: "BlockQuote";
  childNodes: Array<Node>;
}

export interface Item {
  type: "Item";
  childNodes: Array<Node>;
}

export interface List {
  type: "List";
  variant: MarkdownNode["listType"];
  tight: boolean;
  start: number | null;
  delimiter: MarkdownNode["listDelimiter"] | null;
  childNodes: Array<Node>;
}

export interface Heading {
  type: "Heading";
  level: HeadingLevel;
  childNodes: Array<Node>;
}

export type BranchNode =
  | Document
  | TextStyle
  | Link
  | Image
  | Paragraph
  | BlockQuote
  | Item
  | List
  | Heading;

export type Node = BranchNode | LeafNode;

export function isBranch(node: Node): node is BranchNode {
  switch (node.type) {
    case "Text":
    case "TextStyle":
    case "Break":
    case "HTMLInline":
    case "HTMLBlock":
    case "Code":
    case "CodeBlock":
    case "ThematicBreak":
    case "CustomInline":
    case "CustomBlock":
      return false;
    case "Document":
    case "Link":
    case "Image":
    case "Paragraph":
    case "BlockQuote":
    case "Item":
    case "List":
    case "Heading":
      return true;
  }
}

export interface Tree {
  childNodes: Array<Node>;
}

export function initTree(): Tree {
  return { childNodes: [] };
}
